import * as React from 'react'

const SvgArrowLeft = (props) => (

    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        fill="none"
        viewBox="0 0 36 36"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.929"
            d="M28.394 17.996h-20.5m0 0l10.25 10.25m-10.25-10.25l10.25-10.25"
        ></path>
    </svg>
)

export default SvgArrowLeft
